import { createSlice  } from '@reduxjs/toolkit';

const initialState = {
  staffOnlineStat: {
    requesting: false,
    items: [],
    summary: {},
    error: null,
    success: false,
    filters: {},
  }, 
  clientSummaryCards: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
  clientAttendanceTrendChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  payrollOverviewChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  clientActionRequiredSummary: {
    requesting: false,
    data: [],
    error: null,
    success: false,
    filters: {},
  },
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    getStaffOnlineStatus: (state, action) => {		
      state.staffOnlineStat.requesting = true;
      state.staffOnlineStat.error = null;
      state.staffOnlineStat.success = false;
      state.staffOnlineStat.filters = action.payload;
    },
    getStaffOnlineStatusSuccess: (state, action) => {
      const { staffList, summary } = action.payload;
      state.staffOnlineStat.requesting = false;
      state.staffOnlineStat.success = true;
      state.staffOnlineStat.items = staffList;
      state.staffOnlineStat.summary = summary;
    },
    getStaffOnlineStatusFail: (state, action) => {   
      state.staffOnlineStat.requesting = false;
      state.staffOnlineStat.error = action.payload;
      state.staffOnlineStat.success = false;
    },

    getClientSummaryCards: (state, action) => {		
      state.clientSummaryCards.requesting = true;
      state.clientSummaryCards.error = null;
      state.clientSummaryCards.success = false;
      state.clientSummaryCards.filters = action.payload;
    },
    getClientSummaryCardsSuccess: (state, action) => {
      state.clientSummaryCards.requesting = false;
      state.clientSummaryCards.success = true;
      state.clientSummaryCards.items = action.payload;
    },
    getClientSummaryCardsFail: (state, action) => {   
      state.clientSummaryCards.requesting = false;
      state.clientSummaryCards.error = action.payload;
      state.clientSummaryCards.success = false;
    },

    getClientActionRequiredSummary: (state, action) => {		
      state.clientActionRequiredSummary.requesting = true;
      state.clientActionRequiredSummary.error = null;
      state.clientActionRequiredSummary.success = false;
      state.clientActionRequiredSummary.filters = action.payload;
    },
    getClientActionRequiredSummarySuccess: (state, action) => {
      state.clientActionRequiredSummary.requesting = false;
      state.clientActionRequiredSummary.success = true;
      state.clientActionRequiredSummary.data = action.payload;
    },
    getClientActionRequiredSummaryFail: (state, action) => {   
      state.clientActionRequiredSummary.requesting = false;
      state.clientActionRequiredSummary.error = action.payload;
      state.clientActionRequiredSummary.success = false;
    },
  },
})

export const { 
  getStaffOnlineStatus, getStaffOnlineStatusSuccess, getStaffOnlineStatusFail,
  getClientSummaryCards, getClientSummaryCardsSuccess, getClientSummaryCardsFail,
  getClientActionRequiredSummary, getClientActionRequiredSummarySuccess, getClientActionRequiredSummaryFail,
} = dashboardSlice.actions

export default dashboardSlice.reducer